export const S3_AWS_KMS_KEY_ID = "ee48dcb9-9415-4c98-94af-c0edc281df91";

export const JUMIO_CALLBACK_URL = "https://www.bixin.com/trade/kyc";
// export const REACT_APP_HOSTBASE_URL_HK = "https://gateway.bixin.com";
export const SITE_SERVER_API = "https://gateway.bixin.com";
export const EXCHANGE_TRADE_DOMAIN = "https://gateway.bixin.com";
export const PRO_ENV = "PROD";
